// extracted by mini-css-extract-plugin
var _1 = "ChatroomMessageFooter-modulechatroomMessageFooter__YLyc9";
var _2 = "ChatroomMessageFooter-moduleright__AW4C6";
export { _1 as "chatroomMessageFooter", _2 as "right" }
